import { render, staticRenderFns } from "./TabelaParecerDescritivo.vue?vue&type=template&id=e099488e&"
import script from "./TabelaParecerDescritivo.vue?vue&type=script&lang=js&"
export * from "./TabelaParecerDescritivo.vue?vue&type=script&lang=js&"
import style0 from "./TabelaParecerDescritivo.vue?vue&type=style&index=0&id=e099488e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports